export const TRAINING_LOGIN_ALERT_PREFIX = 'mrt-training-login-alert:';

export function clearTrainingLoginAlertFlags() {
  try {
    const keys = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const k = sessionStorage.key(i);
      if (k && k.startsWith(TRAINING_LOGIN_ALERT_PREFIX)) keys.push(k);
    }
    keys.forEach((k) => sessionStorage.removeItem(k));
  } catch {
    /* ignore */
  }
}

export function trainingLoginAlertSessionKey(email, token) {
  const em = String(email || '').trim().toLowerCase();
  const t = String(token || '').trim();
  const tokPart = t ? t.slice(-24) : 'notoken';
  return `${TRAINING_LOGIN_ALERT_PREFIX}${em}:${tokPart}`;
}

export function wasTrainingLoginAlertShown(email, token) {
  try {
    return sessionStorage.getItem(trainingLoginAlertSessionKey(email, token)) === '1';
  } catch {
    return false;
  }
}

export function markTrainingLoginAlertShown(email, token) {
  try {
    sessionStorage.setItem(trainingLoginAlertSessionKey(email, token), '1');
  } catch {
    /* ignore */
  }
}
